import React from 'react'
import QuestionTpl from '../templates/QuestionTpl'
import { Select } from './Select'

const variants = [
    {
        label: 'Small',
        value: 'small'
    },
    {
        label: 'Medium',
        value: 'medium'
    },
    {
        label: 'Large',
        value: 'large'
    },
    {
        label: '4WD',
        value: '4wd'
    }
];

export default class CarVariantQn extends React.Component {

    static id = 'car_variant';
    static defaultValue = variants[1].value; // Medium

    render() {
        const { id, value, onChange } = this.props;

        return (
            <QuestionTpl
                {...this.props}
                title="Car size"
                description="The size of the car"
                fineprint="The size of the car you would like to lease."
                component={Select}
                componentProps={{
                    options: variants,
                    value,
                    onChange: (e) => onChange(id, e.target.value),
                }}
            />
        )
    }
}
